import React from 'react';




function Header (){
    return(
        <div className="header">
        <h2>Шестой международный профессиональный форум <br/>«Книга. Культура. Образование. Инновации» <br/>(«Крым-2021»)
        </h2>
        </div>





    );



}



export default Header